//AUTH0
export const UPDATE_AUTH_USER = 'update_auth_user';
export const SET_AUTH_TOKENS = 'set_auth_tokens';
export const SET_AUTH_REFRESH_TOKEN = 'set_auth_refresh_token';
export const SIGNOUT_AUTH_SUCCESS = 'signout_auth_success';
export const SET_AUTH_FAILED_MSG = 'set_auth_failed_msg'




